import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import AnnouncementBar from "./components/AnnouncementBar";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import AuthorityRibbon from "./components/AuthorityRibbon";
import StatStrip from "./components/StatStrip";
import Manifesto from "./components/Manifesto";
import Ecosystem from "./components/Ecosystem";
import Method from "./components/Method";
import HowWeEngage from "./components/HowWeEngage";
import Certifications from "./components/Certifications";
import InnovationArena from "./components/InnovationArena";
import InauguralEdition from "./components/InauguralEdition";
import Momentum from "./components/Momentum";
import Audiences from "./components/Audiences";
import Industries from "./components/Industries";
import BeyondCourses from "./components/BeyondCourses";
import TalentAcquisition from "./components/TalentAcquisition";
import AdoptionServices from "./components/AdoptionServices";
import ReachUs from "./components/ReachUs";
import PlatformDebut from "./components/PlatformDebut";
import PullQuote from "./components/PullQuote";
import Partners from "./components/Partners";
import Founder from "./components/Founder";
import EnquiryForm from "./components/EnquiryForm";
import SiteFAQ from "./components/SiteFAQ";
import Footer from "./components/Footer";
import StickyWhatsApp from "./components/StickyWhatsApp";
import Popups from "./components/Popups";

const Landing = () => (
  <main className="relative bg-canvas text-ink" data-testid="landing-root">
    <AnnouncementBar />
    <Nav />
    <Hero />
    <AuthorityRibbon />
    <StatStrip />
    <Manifesto />
    <Ecosystem />
    <Method />
    <Audiences />
    <Industries />
    <BeyondCourses />
    <span id="beyond-talent" aria-hidden="true" />
    <TalentAcquisition />
    <AdoptionServices />
    <HowWeEngage />
    <Certifications />
    <InnovationArena />
    <InauguralEdition />
    <Momentum />
    <PlatformDebut />
    <PullQuote
      quote="We're not building another course catalogue. We're building the loop that turns a first prompt into a funded company."
      attribution="THE AI FOR EVERYONE MANIFESTO · MAY 2026"
    />
    <ReachUs />
    <Partners />
    <Founder />
    <EnquiryForm />
    <SiteFAQ />
    <Footer />
    <StickyWhatsApp />
    <Popups />
  </main>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
